var map = {
	"./screen1.png": 260,
	"./screen10.png": 261,
	"./screen2.png": 262,
	"./screen3.png": 263,
	"./screen4.png": 264,
	"./screen5.png": 265,
	"./screen6.png": 266,
	"./screen7.png": 267,
	"./screen8.png": 268,
	"./screen9.png": 269
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 259;